import { Routes, Route } from 'react-router-dom';
import Layout from '../NewUPT/shared/Layout';
import Home from '../NewUPT/homePage/NewUPThomepage.jsx';
import Office from '../../src/NewUPT/office/OfficeDisplay.jsx';
import Staff from '../NewUPT/doctorInfo/DoctorView.jsx';
import Insurance from '../../src/NewUPT/insuranceDetails/insurancePage.jsx';
import Appointments from '../NewUPT/appointments/AppointmentScheduler.jsx';

import RegisterPatient from '../../src/NewUPT/registration/registerPatient.jsx';
import RegisterStaff from '../../src/NewUPT/registration/registerDoctor.jsx';
import LoginPatient from '../../src/NewUPT/loginServices/PatientLogin.jsx';
import LoginDoctor from '../../src/NewUPT/loginServices/DoctorLogin.jsx';

import PatientDashboard from '../../src/NewUPT/DashBoard/PatientDashBoard.jsx';
import DoctorDashboard from '../../src/NewUPT/DashBoard/DoctorDashboard.jsx';

import InsurancePatientReg from '../../src/NewUPT/registration/insurancePatientRegistration.jsx';
import RegisterOffice from '../../src/NewUPT/registration/registerOffice.jsx';
import OfficeSchedule from '../../src/NewUPT/registration/officeScheduleRegistration.jsx';
import PatientAuthorization from '../../src/NewUPT/registration/patientAuthorizationRegistration.jsx';
import RegisterInsurance from '../../src/NewUPT/registration/registerInsurance.jsx';
import ProcedureDiagnosis from '../../src/NewUPT/registration/registrerProcedureDiagnosis.jsx';
import RegisterAdmin from '../../src/NewUPT/Security/RegisterUser.jsx';

import RegisterPromotion from '../../src/NewUPT/promotion/CreatePromotion.jsx';
import RegisterPointItem from '../../src/NewUPT/points/InventoryManager.jsx';

import ContentPage from '../../src/NewUPT/ContentCreater/ContentHandler.jsx'; // For dynamic content

import Terms from '../NewUPT/staticPages/Terms.jsx';
import Privacy from '../NewUPT/staticPages/Privacy.jsx';
import Contact from '../NewUPT/staticPages/Contact.jsx';

import SearchPopupPage from '../NewUPT/popUps/searchPopupPage.jsx'; // adjust path


const RoutesComponent = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/office" element={<Office />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/appointments" element={<Appointments />} />
        <Route path="/dashboard/patient" element={<PatientDashboard />} />
        <Route path="/dashboard/doctor" element={<DoctorDashboard />} />
        <Route path="/register/insurance-patient" element={<InsurancePatientReg />} />
        <Route path="/register/office" element={<RegisterOffice />} />
        <Route path="/register/schedule" element={<OfficeSchedule />} />
        <Route path="/register/authorization" element={<PatientAuthorization />} />
        <Route path="/register/insurance" element={<RegisterInsurance />} />
        <Route path="/register/procedure-diagnosis" element={<ProcedureDiagnosis />} />
        <Route path="/register/admin" element={<RegisterAdmin />} />
        <Route path="/register/promotion" element={<RegisterPromotion />} />
        <Route path="/register/point-item" element={<RegisterPointItem />} />
        <Route path="/content-creator" element={<ContentPage />} />
        <Route path="/register/patient" element={<RegisterPatient />} />
        <Route path="/register/staff" element={<RegisterStaff />} />
        <Route path="/login/patient" element={<LoginPatient />} />
        <Route path="/login/doctor" element={<LoginDoctor />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />

      </Route>

      {/* Public routes (not wrapped with Layout) */}
      
      <Route path="/search-popup" element={<SearchPopupPage />} />

      
    </Routes>
  );
};

export default RoutesComponent;
